import React, {useState, useEffect } from "react";
import { getTodayMarketPL } from "../action/api-services";
import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
// import { Line } from 'react-chartjs-2';
import { Chart } from 'react-chartjs-2';
import './chartjs-register';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);


const TodayPLGraph = ({series}) =>{
    const [getMarketData, setMarketData] = useState([]); 
    const token = useSelector((state) => state.userToken.value);
    
    useEffect(() => {
        if(token){
            let payload = {
                'series': series
            }

            getTodayMarketPL(payload, token).then(function (response) {
                // console.log("response", response.data.data);
                setMarketData(response?.data?.data || []);
            }).catch(function (err) {console.log("Error", err) });
        }

    }, [token]);


    
const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
        display: false
    },
    title: {
        display: false,
    },
    tooltip: {
        enabled: false, 
        external: customTooltip,
    },
  },
  scales: {
    x: {
      // offset: false,
      grid: {
        display: false,       
        drawBorder: false,    
      },
      ticks: { display: false },  
    },
    y: {
      grid: {
        display: false,       
        drawBorder: false,    
      },
      ticks: { display: false },
    },
  },
};

const profitPer = getMarketData?.map(item => item?.profit_per);
const profitPer_diff = getMarketData?.map((item, index) => {
    let newPer = 0;
        if(index === 0){
                // newPer = Math.round(((item.profit - item.loss) * 100 )/item.profit);
                newPer = Math.round(item.profit - item.loss);
        }else{
                newPer =  Math.round(getMarketData[index].profit - getMarketData[index - 1].profit);
        }
        return newPer;  
});


const lossPer = getMarketData?.map(item => item.loss_per);
const times = getMarketData?.map(item => item.time);

const data = {
  labels: times,
  datasets: [   
    {
      type: 'bar',
      data: profitPer,
      borderColor: 'rgb(0, 200, 0)',
      backgroundColor: 'rgb(0, 200, 0)',
      borderWidth: 1.5,
      fill: false,
      order: 1,
      pointRadius: 1.5,  
      barThickness: 4, 
    //   barPercentage: 0.1,
    //   categoryPercentage: 0.1
    },
    {
      type: 'bar',
      data: lossPer,
      borderColor: 'rgb(255, 0, 0)',
      backgroundColor: 'rgb(255, 0, 0)',
      borderWidth: 1.5,
      fill: false,
      order: 2,
      pointRadius: 1.5,  
      barThickness: 4,
    //   barPercentage: 0.1,
    //   categoryPercentage: 0.1 
    },
    // {
    //   type: 'line',
    //   data: profitPer_diff,
    //   borderColor: 'rgb(0, 0, 220)',
    //   backgroundColor: 'rgb(0, 0, 220)',
    //   borderWidth: 1,
    //   fill: false,
    //   order: 3,
    //   pointRadius: 1,  
    // }, 
  ],
};



function customTooltip(context) {
  // Get or create tooltip element
  let tooltipEl = document.getElementById('chartjs-custom-tooltip');
  let toolWrap = document.getElementById('todayChartGH');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'chartjs-custom-tooltip';
    tooltipEl.innerHTML = '<div class="tooltip-content"></div>';
    document.body.appendChild(tooltipEl);
  }

  const tooltipModel = context.tooltip;

  // Hide tooltip
  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  const index = tooltipModel.dataPoints?.[0]?.dataIndex;

  if (index !== undefined) {
    const market = getMarketData[index]; // your data array
    tooltipEl.querySelector('.tooltip-content').innerHTML = `${index+1}) <strong>${market.time}</strong>: <strong style="color:green">${market.profit}</strong> / <strong style="color:red">${market.loss}</strong>`;
  }

  const chart = context.chart;

  const {x: chartX, y: chartY} = chart.tooltip;
  const chartPWrap = toolWrap.offsetParent.offsetLeft;
  const LeftPos = chartPWrap + chartX - 25;

  // console.log("chart", chartPWrap, chartX, chart.tooltip.x, tooltipModel.caretX);
  // console.log("chart", chart)


  tooltipEl.style.opacity = 1;
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.left = LeftPos + 'px';
  tooltipEl.style.top = chartY + tooltipModel.caretY  + 'px';
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.background = '#fff';
  tooltipEl.style.border = '1px solid #ccc';
  tooltipEl.style.borderRadius = '4px';
  tooltipEl.style.padding = '3px 6px';
  tooltipEl.style.fontSize = '11px';
  tooltipEl.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
  tooltipEl.style.zIndex = 1000;
}



// console.log(getMarketData)
    return(
        <div className="todayPLGraph" id="todayChartGH">
            <div className="PLChart">
                {/* <Line options={options} data={data} /> */}
                <Chart options={options} data={data} />
            </div>
        </div>
    )

}
export default TodayPLGraph;